
export const root = {
    transitionDuration: '{transition.duration}'
};

export const tablist = {
    borderWidth: '0 0 1px 0',
    borderColor: '{surface.border}',
    background: 'transparent'
};

export const tab = {
    borderWidth: '0',
    borderColor: 'transparent',
    hoverBorderColor: 'transparent',
    activeBorderColor: 'transparent',
    color: '{text.secondary.color}',
    hoverColor: '{text.color}',
    activeColor: '{text.color}',
    padding: '0.75rem 0.25rem',
    fontWeight: '500',
    margin: '0',
    gap: '0.5rem',
    focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: 'none'
    }
};

export const tabpanel = {
    background: 'transparent',
    color: '{content.color}',
    padding: '1.5rem 0',
    focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: 'none'
    }
};

// Scrollable-strip navigators. PrimeNG overlays them on the strip's edges (position absolute, pinned
// with !important) and expects an opaque background plus a wide halo shadow to hide the tab beneath.
// Our strip is transparent on every surface, so instead of painting over the tab the global tabs
// rule (styles.scss) masks the viewport under each navigator and the strip directive ends the cut
// tab in an ellipsis before it — the halo would only smear the neighbouring tab, so it is off, and
// the button is as narrow as its glyph allows (1.75rem: the 14px chevron with 7px each side, still a
// 28 × 44 px target) so the ellipsis sits close to the chevron.
export const navButton = {
    background: 'transparent',
    color: '{text.muted.color}',
    hoverColor: '{text.color}',
    width: '1.75rem',
    shadow: 'none',
    focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: 'none'
    }
};

// Active bar — sliding indicator under active tab
export const activeBar = {
    height: '2px',
    bottom: '-1px',
    background: '{primary.color}'
};

export const colorScheme = {
    light: {
        tab: {
            background: 'transparent',
            hoverBackground: 'transparent',
            activeBackground: 'transparent'
        }
    },
    dark: {
        tab: {
            background: 'transparent',
            hoverBackground: 'transparent',
            activeBackground: 'transparent'
        }
    }
};

export const css = ({dt}: {dt: (token: string) => string}) => `
.p-tablist-active-bar {
    transition: all 0.25s ease;
}
`;

export default {
    root,
    tablist,
    tab,
    tabpanel,
    navButton,
    activeBar,
    colorScheme,
    css
};
